import React, { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import { UserContext, UserContextPayload } from '../../../../context/userContext';
import GlobalButton from '../../../utility/globalButton/button';
import styles from '../../../../assets/styles/componentStyles/chatbotStyles/scheduleMeetingPopup.module.scss';

interface ScheduleMeetingPopupProps {
    setFlagScheduleMeetingPopup: React.Dispatch<React.SetStateAction<boolean>>;
    integrationName: string;
}

const ScheduleMeetingPopup: React.FC<ScheduleMeetingPopupProps> = (props) => {
    const { setFlagScheduleMeetingPopup, integrationName } = props;
    const { setFlagShowScheduleCall } = useContext(UserContext) as UserContextPayload;

    return (
        <Box className={styles.card}>
            <Box className={styles.iconContainer}>
                <EventAvailableOutlinedIcon className={styles.icon} />
            </Box>
            <Typography className={styles.description}>
                Contact our support team to integrate with {integrationName}.
            </Typography>
            <Box className={styles.buttonContainer}>
                <GlobalButton
                    buttonText={"Schedule Meeting"}
                    sx={{ width: "190px" }}
                    className='primaryButtonStyle'
                    onClick={() => { setFlagScheduleMeetingPopup(false); setFlagShowScheduleCall(true)}}
                />
            </Box>
        </Box>
    );
};

export default ScheduleMeetingPopup;
